import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="space-y-20 py-20">
      {/* Main About Section */}
      <section className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">About Civic Guru</h1>
          <p className="text-xl text-gray-600 mb-12">
            Access to legal services is often expensive and out of reach for many individuals,
            particularly in underserved communities. Complex legal jargon and a lack of affordable
            legal professionals make it challenging for people to understand their rights and
            navigate legal processes.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="bg-gray-50 py-20">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://picsum.photos/600/400"
                alt="Why Civic Guru"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-gray-900">Why Civic Guru?</h2>
              <p className="text-gray-600 text-lg">
                Civic Guru bridges this gap by providing an affordable, AI-powered assistant that
                simplifies legal language, offers instant guidance, and connects users to trusted
                legal experts when needed. Our goal is to make justice accessible to everyone,
                regardless of their financial or educational background.
              </p>
              <Link
                to="/"
                className="inline-block bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition-colors"
              >
                Start Using Civic Guru
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Our Values</h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center space-y-4">
            <h3 className="text-xl font-semibold text-gray-900">Accessibility</h3>
            <p className="text-gray-600">
              Making legal information available to everyone through simple, everyday language.
            </p>
          </div>
          <div className="text-center space-y-4">
            <h3 className="text-xl font-semibold text-gray-900">Reliability</h3>
            <p className="text-gray-600">
              Providing accurate, up-to-date legal information you can trust.
            </p>
          </div>
          <div className="text-center space-y-4">
            <h3 className="text-xl font-semibold text-gray-900">Empowerment</h3>
            <p className="text-gray-600">
              Helping individuals understand and exercise their legal rights effectively.
            </p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-blue-600 text-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-6">Join Us in Making Legal Help Accessible</h2>
          <p className="text-xl mb-8">
            Start your journey with Civic Guru today and experience simplified legal assistance.
          </p>
          <Link
            to="/"
            className="bg-white text-blue-600 px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors inline-block"
          >
            Get Started Now
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About; 